import React from "react";
import BlogFortyOne from "../component/BlogFortyOne";

function BlogFortyOneContainer() {
  return <BlogFortyOne />;
}

export default BlogFortyOneContainer;
